import styled from 'styled-components';

import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { Marker } from '@xing-com/marker';
import { ProfileImage } from '@xing-com/profile-image';
import { spaceXS, spaceS, spaceM } from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

import { CardElementLink } from './card-element-link';

const Company = styled.div`
  display: flex;
`;

const CompanyLink = styled(CardElementLink)`
  align-items: flex-start;
  margin-bottom: ${spaceM};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
`;

const CompanyText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

const Logo = styled(ProfileImage)`
  margin-right: ${spaceS};
`;

const Name = styled(Headline)`
  ${lineClamp(1)}
  word-break: break-word;
  margin: 0;
`;

const Location = styled(BodyCopy)`
  ${lineClamp(1)}
  word-break: break-word;
  margin: 0;
`;

const LocationContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CompanyDescription = styled(BodyCopy)<{ $extraLines?: number }>`
  flex-shrink: 1;
  margin: ${spaceXS} 0 ${spaceXS} 40px;
  ${({ $extraLines }) => lineClamp(1 + ($extraLines || 0))}
`;

const KununuValue = styled(Marker)`
  margin: 0 0 0 ${spaceM};
`;

export default {
  Company,
  CompanyLink,
  CompanyText,
  Logo,
  Name,
  Location,
  LocationContainer,
  CompanyDescription,
  KununuValue,
};
